import React from "react";
import Header from "../../Components/Header";
import Category from "../../Components/Category";
import CategoryHeading from "../../Components/CategoryHeading";
import Card from "../../Components/Card";
import Image from "../../Assets/Images/Cables/All Types of Cables.jpg";
import Image1 from "../../Assets/Images/Cables/All Types of FLexible Cable.jpg";
import Image2 from "../../Assets/Images/Cables/Home Wiring.png";
import Image3 from "../../Assets/Images/Cables/35 x 4 Core Standard.jpg";
import Image4 from "../../Assets/Images/Cables/Solid Wire.png";
import Footer from "../../Components/Footer/indes";

function Cable() {
  return (
    <>
      <div style={{ height: 80 }}>
        <Header />
      </div>
      <Category />
      <CategoryHeading Title={"Our Cables"} />

      <div className="my-cards">
        <Card Image={Image} Title={"ALL Types of Cables"} />
        <Card Image={Image1} Title={"All Types of Flexible Cables"} />
        <Card Image={Image2} Title={"Home Wiring"} />
        <Card Image={Image3} Title={"35 x 4 Core Standard"} />
        <Card Image={Image4} Title={"Solid Wire"} />
      </div>
      <Footer />
    </>
  );
}

export default Cable;
